import type { Obj } from '../../typescript';
import { makeStringTemplate } from '../../utils/string/make-string-template';

import type { EndpointMethodKeys } from './create-api/create-api.model';

type EndpointUriMethod = Uppercase<EndpointMethodKeys>;

type DefineEndpointsShape = Partial<Record<EndpointUriMethod, Obj<unknown>>>;

type DefineNamespacedEndpointsShape = {
    [key: string]: {
        [Method in EndpointUriMethod]?: unknown;
    };
};

/**
 *
 * @example
 * ```typescript
 *  const USER_ENDPOINTS = defineEndpoints((template) => ({
 *    GET_USER: template('/api/users/{userId}'),
 *    UPDATE: template('/api/users/{userId}'),
 *    SIGNUP: '/api/users/signup' as const, // or template('/api/users/signup')
 *  }));
 * ```
 */
const defineEndpoints = <T extends DefineEndpointsShape | DefineNamespacedEndpointsShape>(
    endpoints: (makePathTemplate: typeof makeStringTemplate) => T,
) => {
    return endpoints(makeStringTemplate);
};

export { defineEndpoints };
